
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import ServicesContent from '../../components/Service/ServicesContent.vue';

    export default {
        head: function () {
            return {
                title: this.$store.state.servicesPageData.meta_title || this.$nuxt.$options.head.title,
                meta: [
                    { hid: 'description', name: 'description', content: this.$store.state.servicesPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },

                    { hid: 'og:title', property: 'og:title', content: this.$store.state.servicesPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'og:description', property: 'og:description', content: this.$store.state.servicesPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'og:image', property: 'og:image', content: this.$store.state.servicesPageData.background_image },

                    { hid: 'twitter:title', name: 'twitter:title', content: this.$store.state.servicesPageData.meta_title || this.$nuxt.$options.head.title },
                    { hid: 'twitter:description', name: 'twitter:description', content: this.$store.state.servicesPageData.meta_desc || this.$nuxt.$options.head.meta.find(meta => meta.name === 'description').content },
                    { hid: 'twitter:image', name: 'twitter:image', content: this.$store.state.servicesPageData.background_image }
                ],
            };
        },
        components: {
            ServicesContent,
            HeadingSection,
        },
        computed: {
            servicesPageData() {
                return this.$store.state.servicesPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/15`)
                .then((response) => {
                    context.store.dispatch("setServicesPageData", response.data.acf);
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
